// extracted by mini-css-extract-plugin
export default {"mainContent":"App_mainContent__qBoGT","mainContentBody":"App_mainContentBody__UoKZe"};